import { Skeleton } from '@/components/ui/skeleton';

export function ForumCardSkeleton() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-5 rounded" />
          <Skeleton className="h-4 w-24" />
        </div>
        <Skeleton className="h-3 w-3 rounded" />
      </div>
      <Skeleton className="h-5 w-3/4 mb-2" />
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-2/3 mb-3" />
      <div className="flex gap-1.5 mb-3">
        <Skeleton className="h-5 w-12 rounded-lg" />
        <Skeleton className="h-5 w-10 rounded-lg" />
        <Skeleton className="h-5 w-14 rounded-lg" />
      </div>
      <div className="flex items-center gap-1">
        <Skeleton className="h-3 w-3" />
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  );
}
